module.exports = __webpack_public_path__ + "img/robinhood.6898cd40.png";